import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
// @ utilities
import { FormattedText } from 'core/i18n';

const DEFAULT_REQUERIMENT_TEXTS = {
    ['id']: 'initial-creditCardProcessRequerimentId',
    ['mobile']: 'initial-creditCardProcessRequerimentMobile',
    ['income']: 'initial-creditCardProcessRequerimentIncome',
    ['iban']: 'initial-creditCardProcessRequerimentIban',
};

export default class RequerimentText extends Component {
    render() {
        const BASE_CLASSNAME = 'font-heading6';
        const { type } = this.props;

        return (
            <Fragment>
                <i className={`icons icons--icon-process-documents-${type}`} />
                <h6 className={type === 'id' ? `${BASE_CLASSNAME} document-id` : BASE_CLASSNAME}>
                    <FormattedText value={DEFAULT_REQUERIMENT_TEXTS[type]} />
                </h6>
            </Fragment>
        );
    }
}

RequerimentText.propTypes = {
    type: PropTypes.oneOf(['id', 'mobile', 'income']),
};

RequerimentText.defaultProps = {
    type: 'id',
};
